var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "DiscForm",
      on: {
        click: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "content-box",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("div", { staticClass: "title" }, [
            _c("h2", [_vm._v(" " + _vm._s(_vm.$t("DISCIPLINEFORM.TITLE")))])
          ]),
          _c(
            "form",
            [
              _c(
                "div",
                { staticClass: "form-block-select" },
                [
                  _c("BaseSelectForm", {
                    attrs: {
                      value: _vm.discipline,
                      label: _vm.$t("DISCIPLINEFORM.DISCIPLINES"),
                      tag: "discipline",
                      options: _vm.getDisc
                    },
                    model: {
                      value: _vm.discipline,
                      callback: function($$v) {
                        _vm.discipline = $$v
                      },
                      expression: "discipline"
                    }
                  }),
                  _c("BaseSelectForm", {
                    attrs: {
                      value: _vm.lenguage,
                      label: _vm.$t("EDITFORM.LENGUAGE"),
                      tag: "lenguage",
                      options: _vm.getLen
                    },
                    model: {
                      value: _vm.lenguage,
                      callback: function($$v) {
                        _vm.lenguage = $$v
                      },
                      expression: "lenguage"
                    }
                  }),
                  _c("BaseSelectForm", {
                    attrs: {
                      value: _vm.condition,
                      label: _vm.$t("EDITFORM.CONDITIONS"),
                      tag: "condition",
                      options: _vm.getCon
                    },
                    model: {
                      value: _vm.condition,
                      callback: function($$v) {
                        _vm.condition = $$v
                      },
                      expression: "condition"
                    }
                  }),
                  _c("BaseSelectForm", {
                    attrs: {
                      value: _vm.percentage,
                      label: _vm.$t("EDITFORM.PERCENTAGE"),
                      tag: "percentage",
                      options: _vm.getPer
                    },
                    model: {
                      value: _vm.percentage,
                      callback: function($$v) {
                        _vm.percentage = $$v
                      },
                      expression: "percentage"
                    }
                  })
                ],
                1
              ),
              _c("div", { staticClass: "form-block" }, [
                _c("div", { staticClass: "fileInput" }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("EDITFORM.IMAGE")))]),
                  _c("input", {
                    attrs: { type: "file", name: "imagen" },
                    on: { change: _vm.loadImage }
                  })
                ])
              ]),
              _c("BaseText", {
                attrs: {
                  label: _vm.$t("AUTHOR.DESCRIPTION"),
                  tag: "desc",
                  type: "text",
                  placeholder: _vm.$t("EDITFORM.DESCRIPTION")
                },
                scopedSlots: _vm._u([
                  {
                    key: "error",
                    fn: function() {
                      return [
                        _c("ValidationError", {
                          attrs: { errors: _vm.errors, name: "desc" }
                        })
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.desc,
                  callback: function($$v) {
                    _vm.desc = $$v
                  },
                  expression: "desc"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "button-sub" },
            [
              _c(
                "BaseButton",
                {
                  on: { click: _vm.submitData },
                  nativeOn: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("BUTTON.SAVE")) + " ")]
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }